import React from 'react'
import Layout from 'components/Layout'
import RenderSubRoutes from 'components/RenderSubRoutes'
import getAdminRoutes from './getRoutes/getAdminRoutes'
import routes from 'constants/routes'
import { useParams } from 'react-router-dom'
import SidebarDetailTemplatesAccordian from 'components/Sidebars/SidebarDetailTemplatesAccordian'

const Admin_SiteDetails_Show = tool => {
	const { toolType } = useParams()

	const subRoutes = getAdminRoutes(toolType)

	return (
		<Layout>
			<Layout.SecondaryNav
				links={subRoutes}
				backLink={{ title: 'Admin Tools', link: routes.ADMIN }}
				sourceName={`Admin Tools`}
			/>

			<Layout.Page>
				<Layout.Sidebar isOffset>
					<Layout.SidebarUserCard />
					<SidebarDetailTemplatesAccordian />
				</Layout.Sidebar>
				<Layout.Body>
					<RenderSubRoutes routes={subRoutes} />
				</Layout.Body>
			</Layout.Page>
		</Layout>
	)
}

export default Admin_SiteDetails_Show
